<template>
    <div class="create-lottery">
        <h1>创建抽奖</h1>

        <form @submit.prevent="submitForm">
            <table class="form-table">
                <tbody>
                    <!-- 基本设置 -->
                    <tr>
                        <th colspan="2">基本设置 ( 各种邀请、VPS、节点或个人闲置等 )</th>
                    </tr>
                    <tr>
                        <td><label>奖品&nbsp;(份)</label></td>
                        <td>
                            <el-select v-model="form.prizes" multiple filterable allow-create
                                placeholder="自定义输入后会创建下拉菜单，如：三个鸡蛋">
                                <el-option v-for="item in form.prizeOptions" :key="item" :label="item"
                                    :value="item"></el-option>
                            </el-select>
                        </td>
                    </tr>

                    <tr>
                        <td><label>数量&nbsp;(份)</label></td>
                        <td><el-input v-model.number="form.prizeCount" type="number" min="1" /></td>
                    </tr>

                    <tr>
                        <td><label>中奖人数</label></td>
                        <td><el-input v-model.number="form.winnerCount" type="number" min="1" /></td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;"><label>简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;介：</label>
                        </td>
                        <td>
                            <el-input type="textarea" v-model="form.content" :rows="3" placeholder="活动说明..." />

                        </td>
                    </tr>

                    <!-- 抽奖设置 -->
                    <tr>
                        <th colspan="2">抽奖设置 ( 多选后满足任意条件即可 )</th>
                    </tr>

                    <tr>
                        <td><label>最低开奖人数</label></td>
                        <td>
                            <div style="display: flex;">
                                <el-checkbox v-model="form.isLimitLotteryOfPeople" />
                                <el-input v-model.number="form.numberOfPeople" type="number" min="1" />
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><label>限制报名人数</label></td>
                        <td>
                            <div style="display: flex;">
                                <el-checkbox v-model="form.isLimitNumberOfPeople" />
                                <el-input v-model.number="form.maxNumberOfPeople" type="number" />
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><label>自动开奖时间</label></td>
                        <td>
                            <div style="display: flex;">
                                <el-checkbox v-model="form.isForcedToBeDrawnAtTime" />
                                <!-- <el-input v-if="form.isForcedToBeDrawnAtTime" v-model="form.autoDrawTime"
                               style="width: 140px;" type="datetime-local" /> -->
                                <el-input v-model="form.deadTime" type="datetime-local" />
                            </div>

                        </td>
                    </tr>

                    <tr>
                        <td><label>自动开奖人数</label></td>
                        <td>
                            <div style="display: flex;">
                                <el-checkbox v-model="form.isFullOfPeopleToDrawn" />
                                <el-input v-model.number="form.toDrawnOfPeople" type="number" max="1000" />

                            </div>
                        </td>
                    </tr>

                    <!-- 参与设置 -->
                    <tr>
                        <th colspan="2">参与设置 ( 必须满足勾选条件，留空不限制 )</th>
                    </tr>

                    <tr>
                        <td><label>需活跃用户</label></td>
                        <td>
                            <div style="display: flex; align-items: center; flex-wrap: nowrap;">
                                <el-checkbox v-model="form.allowLivenessUser" />
                                <label style="margin: 0 10px; white-space: nowrap;">活跃值 >=</label>
                                <el-input v-model.number="form.maxAllowLivenessUser" type="number" min="5" />
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td><label>需认证用户</label></td>
                        <td><el-checkbox v-model="form.allowVerifiedUser" /></td>
                    </tr>

                    <tr>
                        <td><label>需站内用户</label></td>
                        <td><el-checkbox v-model="form.allowInternalUser" /></td>
                    </tr>

                    <tr>
                        <td><label>参与关键词</label></td>
                        <td><el-input v-model="form.command" type="text" /></td>
                    </tr>

                    <!-- <tr>
                        <td colspan="2" style="text-align:center">
                            <el-button type="primary" native-type="submit">创 建</el-button>
                        </td>
                    </tr> -->
                </tbody>
            </table>
        </form>

        <pre class="preview">
      {{ form }}
    </pre>
    </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
const tg = window.Telegram?.WebApp || ''

const form = reactive({
    userId: null,
    username: '',
    firstName: '',
    lastName: '',
 
    prizes: '', // 奖品列表
    prizeCount: 1, // 奖品数量
    winnerCount: 1, // 中奖人数
    content: '',
    prizeOptions: ['一枚邀请碎片', '十两碎银(10000文)'],

    deadTime: '',
    numberOfPeople: 100,
    maxNumberOfPeople: 500,
    isLimitLotteryOfPeople: false,
    isLimitNumberOfPeople: false,
    isForcedToBeDrawnAtTime: false,
    isFullOfPeopleToDrawn: false,
    toDrawnOfPeople: 300,

    allowLivenessUser: true,
    allowNormalUser: false,
    allowVerifiedUser: false,
    allowInternalUser: false,

    maxAllowLivenessUser: 30,

    command: '',
    warn: ''
})

onMounted(() => {
    if (tg) {
        tg.ready() // 等 WebApp 初始化完成
        if (tg.initDataUnsafe?.user) {
            const user = tg.initDataUnsafe.user
            form.userId = user.id
            form.username = user.username || ''
            form.firstName = user.first_name || ''
            form.lastName = user.last_name || ''

            tg.MainButton.setText("提 交")
            tg.MainButton.show()

            tg.MainButton.onClick(() => {
                form.warn = '正在发送数据'
                tg.sendData(JSON.stringify(form))
            })
        } else {
            console.warn('用户信息不存在，确保从 Telegram 打开 Web App')
            form.warn = '用户信息不存在，确保从 Telegram 打开 Web App'
        }
    } else {
        console.warn('tg 未定义，可能不是从 Telegram 打开')
        form.warn = 'tg 未定义，可能不是从 Telegram 打开'
    }
})

const submitForm = () => {
    console.log('提交数据:', form)
    alert('抽奖创建成功！')
}
</script>

<style scoped>
.form-table td {
    padding: 8px;
    border: 1px solid #ddd;
    text-align: left;
    /* 左对齐所有单元格 */
    vertical-align: middle;
    /* 垂直居中，看起来整齐 */

}

.form-table td:first-child {
    width: 35%;
    /* 左列宽 */
    text-align: right;
    /* label 靠右对齐更整齐 */
    padding-right: 10px;
}

.form-table td:last-child {
    width: 65%;
    /* 右列宽 */
    text-align: left;
}

/* 针对表单内的 checkbox */
.create-lottery :deep(.el-checkbox) {
    margin-right: 10px;
    /* 右边间距 */
    vertical-align: middle;
    /* 可选，垂直居中 */
}

.create-lottery {
    max-width: 500px;
    margin: auto;
}

.form-table {
    width: 100%;
    border-collapse: collapse;

}

.form-table td,
.form-table th {
    padding: 8px;
    border: 1px solid #ddd;

}

.form-table th {
    background: #f0f0f0;
    text-align: left;
}
</style>
